var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteWeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1647_17582)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32.0605,
    r: 32,
    fill: "white",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32.0605,
    r: 31.5,
    stroke: "white",
    strokeOpacity: 0.08
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1647_17582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.1435 25.2395L43.143 25.2404L37.1935 35.4396C37.1934 35.4397 37.1933 35.4399 37.1932 35.44C36.8827 35.974 36.7572 36.4747 36.856 36.895C37.4223 39.2446 40.2783 41.25 44.0014 41.25C47.7245 41.25 50.5806 39.2446 51.1468 36.8949C51.2456 36.4748 51.1201 35.9742 50.8098 35.4404L43.1435 25.2395ZM43.1435 25.2395C43.3197 24.9365 43.6457 24.75 44.0014 24.75C44.3525 24.75 44.6819 24.9389 44.8605 25.2416C44.8608 25.242 44.861 25.2424 44.8612 25.2428L50.8094 35.4396L43.1435 25.2395ZM35.4022 18.451L35.6272 18.75H36.0014H44.0014C44.6935 18.75 45.2514 19.308 45.2514 20C45.2514 20.692 44.6935 21.25 44.0014 21.25H36.9014H36.2875L36.1662 21.8518C35.8906 23.2193 34.9507 24.3516 33.7028 24.8933L33.2514 25.0892V25.5813V44V44.75H34.0014H44.0014C44.6935 44.75 45.2514 45.308 45.2514 46C45.2514 46.692 44.6935 47.25 44.0014 47.25H32.0014H20.0014C19.3094 47.25 18.7514 46.692 18.7514 46C18.7514 45.308 19.3094 44.75 20.0014 44.75H30.0014H30.7514V44V25.5813V25.0911L30.3025 24.8943C29.0517 24.3461 28.1119 23.2122 27.8365 21.8513L27.7149 21.25H27.1014H20.0014C19.3094 21.25 18.7514 20.692 18.7514 20C18.7514 19.308 19.3094 18.75 20.0014 18.75H28.0014H28.3756L28.6007 18.451C29.3782 17.4178 30.6106 16.75 32.0014 16.75C33.3923 16.75 34.6246 17.4178 35.4022 18.451ZM38.8285 35.6223L38.1711 36.75H39.4764H48.5327H49.8389L49.1804 35.6219L44.6491 27.8594L44.001 26.749L43.3535 27.8598L38.8285 35.6223ZM20.5741 27.8594L19.926 26.749L19.2785 27.8598L14.7535 35.6223L14.0961 36.75H15.4014H24.4577H25.7639L25.1054 35.6219L20.5741 27.8594ZM19.0742 25.2404L19.0748 25.2395C19.251 24.9365 19.5769 24.75 19.9327 24.75C20.2839 24.75 20.6134 24.939 20.792 25.2419C20.7921 25.2422 20.7923 25.2425 20.7925 25.2428L26.7406 35.4396C27.0511 35.9734 27.1768 36.474 27.0783 36.8942C26.5059 39.2453 23.6484 41.25 19.9264 41.25C16.2041 41.25 13.3536 39.2452 12.7872 36.8949C12.6884 36.4747 12.814 35.9738 13.1246 35.4398C13.1247 35.4397 13.1247 35.4396 13.1247 35.4396L19.0742 25.2404Z",
    stroke: "white",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1647_17582",
    x: -3.6,
    y: -3.53945,
    width: 71.2,
    height: 71.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1647_17582"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1647_17582",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1647_17582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 32,
    fill: "white",
    transform: "translate(12 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteWeight);
export default __webpack_public_path__ + "static/media/white_weight.aa643cc4488d2bba95cf318d844cfb02.svg";
export { ForwardRef as ReactComponent };